import $ from 'jquery';
const ELEMENT_SELECTOR = '.js__init-modal';
export default class CustomerDeviceModal {
    static init() {
        if ($(ELEMENT_SELECTOR).length) {
            $(ELEMENT_SELECTOR).each((index, element) => {
                $(element).on('click', e => {
                    e.preventDefault();
                    const deviceTypeFilters = ['holder', 'charger', 'multi_set'];
                    const deviceTypeSelected = $(element).data('device-type');
                    const $deviceItem = $('.js__user-device-item');
                    $deviceItem.each((index, element) => {
                        const $element = $(element);
                        const isFilterableData = deviceTypeFilters.includes(deviceTypeSelected);
                        $element.toggleClass('d-none', isFilterableData && deviceTypeSelected !== $element.data('device-type'));
                    });
                    $('.js__empty-modal-message').toggle(!$deviceItem.filter(':not(.d-none)').length);
                    const deviceParent = $(e.currentTarget).closest('.js__set-device-value');
                    // @ts-ignore
                    $('.js__device-modal').customerDeviceModal(deviceParent);
                });
            });
        }
    }
}
